module.exports = __webpack_public_path__ + "img/jk8.324ea257.png";